import { TourModel } from "@core/services/api.service";

export class WorkSplitAction {
    static readonly type = '[Work Split] Split Work';

    constructor(public category: number, public userId: string[] | undefined) { }
}

export class WorkSplitSuccessAction {
    static readonly type = '[Work Split] Work split Success';

    constructor(public payload: { tour: TourModel[] }) { }
}

export class WorkSplitFailAction {
    static readonly type = '[Work Split] Work Split Fail';
}

// workload Un-slit
export class WorkUnSplitAction {
    static readonly type = '[Workload Un-Split] Un-Split Work';
}

export class WorkUnSplitSuccessAction {
    static readonly type = '[Workload Un-Split] Workload Un-split Success';

    constructor(public payload: { tour: TourModel[] }) { }
}

export class WorkUnSplitFailAction {
    static readonly type = '[Workload Un-Split] Workload Un-Split Fail';
}

